import React from "react";
import { Helmet } from "react-helmet";

const SeoPixel = ({title_form, description, keywords, image, url}) => {
    return (
        <Helmet>
            <title>{title_form}</title>
            <meta name='description' content={description} />
            <meta name='keywords' content={keywords} />
            <meta name='author' content='Innovation & Content Delivery Center' />
            <meta property='og:title' content={title_form} />
            <meta property='og:description' content={description} />
            <meta property='og:image' content={image} />
            <meta property='og:url' content={url} />
        </Helmet>
    );
};

export default SeoPixel;